module.exports = __webpack_public_path__ + "static/media/milestones.fed748ce.webp";